import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SCREEN_TYPES } from '../breakpoint/custom-breakpoints';

@Component({
  selector: 'vfs-template-all-in-router',
  templateUrl: './template-all-in-router.component.html',
  styleUrls: ['./template-all-in-router.component.scss']
})
export class TemplateAllInRouterComponent {
  @Input() container: string;
  @Input() actionBarActive = true;
  @Input() smallTemplate = true;

  mode = 'default';

  protected destroyed = new Subject();

  constructor(protected breakpointObserver: BreakpointObserver) {
    // FIXME: This subscription is never close
    this.breakpointObserver
      .observe([SCREEN_TYPES.SMALL])
      .pipe(takeUntil(this.destroyed))
      .subscribe(result => {
        if (result.matches) {
          this.mode = 'small';
        } else {
          this.mode = 'default';
        }
      });
  }
}
